<template>
  <div class="home">
    <img :src="imgUrl" alt="" />
    <el-container>
      <el-header>
        <HeadView />
      </el-header>
      <el-main class="main-wrap">
          <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import HeadView from "@/components/HeadView.vue";
export default {
  name: "HomeView",
  components: {
    HeadView,
  },
  data() {
    return {
      imgUrl: require("@/assets/image/shengtai-bg.jpg"),
      route: "",
    };
  },
  watch: {
    route(newPath) {
      if (newPath == "/ECommerceAlliance") {
        this.imgUrl = require("../assets/image/维度电商联盟-bg.jpg");
      } else if (newPath == "/") {
        this.imgUrl = require("@/assets/image/shengtai-bg.jpg");
      } else if (newPath == "/logoPage") {
        this.imgUrl = require("../assets/image/logoPage.jpg");
      } else if (newPath == "/logisticsView") {
        this.imgUrl = require("../assets/image/仓储物流-bg.jpg");
      } else if (newPath == "/technologyView") {
        this.imgUrl = require("../assets/image/technology/技术产品-bg.jpg");
      } else if (newPath == "/onlineRetailers") {
        this.imgUrl = require("../assets/image/operate/电商运营体系-bg.jpg");
      }else if(newPath == "/memoirView"){
        this.imgUrl = require("../assets/image/memoirView/memoirView-bg.jpg");
      }
    },
  },
  mounted() {
    setInterval(() => {
      this.route = this.$route.path;
    }, 50);
  },
};
</script>
<style lang="scss" scoped>
.home {
  // min-width: 1820px;
  width: 100%;
  position: relative;
}
.home img {
  z-index: -9999;
  width: 100%;
  height: 100%;
  position: absolute;
}
.el-header {
  padding: 0;
  height: 112px !important;
}
.el-main {
  padding: 0;
}
.main-wrap {
  padding-bottom: 190px;
}
</style>
